// extracted by mini-css-extract-plugin
module.exports = {"footer":"ShareNftModal_footer__18HJQ","textarea":"ShareNftModal_textarea___4x4e","promote-text":"ShareNftModal_promote-text__3SkLa"};